import breakpoints from '../../../theme/breakpoints'
import theme from '../../../theme/news12'
import redesignedTheme from '../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`
  .main-layout-container {
    display: block;
    width: 100%;
  }

  .main-layout {
    display: inline-block;
    width: 100%;
    margin: 0 auto;
    background-color: ${redesignedTheme.colors.white};
  }
      
  .top-stories {
    max-width: 1480px;
    margin: 0 auto;
    padding: 24px;
    margin-top: 30px;
  }
  
  .top-stories-title {
    color: ${redesignedTheme.colors.mineShaft};
    border-bottom: 2px solid ${redesignedTheme.colors.lightBlue};
    font-size: 1.65em;
    font-weight: 500;
    width: 100%;
    padding: 0 0 6px 0;
    margin-bottom: 20px;
  }
  
  .main-layout .top-stories{
    display: flex;
    flex-wrap: wrap;
  }
  
  .top-stories-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }
  
  @media only screen and (max-width: ${breakpoints.md}px) {
    .main-layout-container {
      width: 100%;
      background-color: ${theme.colors.drWhite};
      padding-top: 20px;
    }

    .main-layout {
      display: block;
      background-color: ${theme.colors.drWhite};
      width: 100%;
    }
    
    .top-stories {
      margin-top: 24px;
    }   
    
    .top-stories-title {
      display: block;
      margin: 0 auto;
      font-size: 1.22em;
    }
  }  
`
